import { render, staticRenderFns } from "./the-integrations.vue?vue&type=template&id=660d6397&scoped=true"
import script from "./the-integrations.vue?vue&type=script&lang=js"
export * from "./the-integrations.vue?vue&type=script&lang=js"
import style0 from "./the-integrations.vue?vue&type=style&index=0&id=660d6397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660d6397",
  null
  
)

export default component.exports